<template>
  <div>
    <div class="con-head">
      <div><img style="height: 100%;position: absolute" src="../assets/head-logo.png"/></div>
      <div class="con-btn" @click="schoolApply()">高校申请试用</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headMenu",
  data(){
    return{
      conShow:true
    }
  },
  mounted() {

  },
  methods:{
    schoolApply(){
      this.$emit('showApply')
    },
  }
}
</script>

<style scoped>
  .con-head{
      position: fixed;
      height: 64px;
      background: #005CE5;
      margin: auto;
      left: 0;
      top: 0;
      right: 0;
      display: flex;
      z-index: 9999;
  }
  .con-btn{
      width: 110px;
      height: 28px;
      font-size: 14px;
      background: #FFFFFF;
      border-radius: 28px;
      color: #DC4900;
      line-height: 28px;
      position: absolute;
      margin: auto;
      top: 18px;
      right: 10px;
  }
</style>